import React from 'react';

import PropTypes from 'prop-types';

import { URL_PLACEHOLDER } from 'constants/UrlConstants';

import { DateAndLocation } from './DateAndLocation';
import { BadgesContainer, ImgContainer, Subtitle, TileBlogContainer, TileBlogContent, Title } from './styles';
import { PromoBadge } from '../PromoBadge/PromoBadge';
import { PromoDangerouslyHtml } from '../PromoDangerouslyHtml/PromoDangerouslyHtml';
import { PromoRow } from '../PromoRow/PromoRow';

export const BlogTile = (props) => {
    const imgPlaceholder = URL_PLACEHOLDER + `/blog-and-news-placeholder@2x.png`;
    return (
        <TileBlogContainer href={props.link} isNewsPage={props.isNewsPage} data-testid="tile-blog-container">
            <ImgContainer isNewsPage={props.isNewsPage}>
                <img src={props.img && props.img.url ? props.img.url : imgPlaceholder} alt={props.img?.alternativeText} loading={'lazy'} decoding={'async'} />
            </ImgContainer>
            {props.title && (
                <TileBlogContent>
                    {props.date && (
                        <PromoRow indent="adaptive-8-12">
                            <DateAndLocation date={props.date} textVariant="span" />
                        </PromoRow>
                    )}
                    <Title>
                        <PromoDangerouslyHtml tag="div" variant="subheader" color="primary" dangerouslyHtml={props.title} />
                    </Title>

                    <Subtitle>
                        <PromoDangerouslyHtml tag="div" color="gray80" dangerouslyHtml={props.text} />
                    </Subtitle>

                    <BadgesContainer>
                        {Array.isArray(props.categories) &&
                            props.categories
                                .filter((item) => item !== null)
                                .map((item) => {
                                    return <PromoBadge key={item.id} caption={item.title} isInactive />;
                                })}
                    </BadgesContainer>
                </TileBlogContent>
            )}
        </TileBlogContainer>
    );
};

BlogTile.propTypes = {
    date: PropTypes.string,
    link: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    img: PropTypes.object,
    isNewsPage: PropTypes.bool,
};
